import script from "./MyTimeSelectorInSeconds.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyTimeSelectorInSeconds.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__